import { http } from '../../config/axios'

 const graficoConsumo = (idFranquia:string): Promise<any> => {
  
  return http
    .get('api/consumo/grafico/'+idFranquia)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro graficoConsumo', error)
      throw Error(error.response.data)
    })
}

export default graficoConsumo;
